import axios from 'axios'

export default {
    get: () => axios.get('awards'),
    getActives: () => axios.get('active-awards'),
    getFiltered: (data) => axios.post('awards', data),
    show: (id) => axios.get('awards/'+id+'/show'),
    store: (data) => axios.post('awards/store', data),
    update: (data) => axios.post('awards/update', data),
    delete: (id) => axios.post('awards/delete', id),
    reactive: (data) => axios.post('awards/reactive', data),
    deactive: (data) => axios.post('awards/deactive', data),

    //puntos canjeables
    getExchanges: () => axios.get('award-exchanges'),
    paid: (data) => axios.post('award-exchanges/paid', data),
    unpaid: (data) => axios.post('award-exchanges/unpaid', data),
    getPendings: () => axios.get('award-exchanges/pendings'),
    getExcelPendings: () => axios.get('award-exchanges/pendings-excel'),
    getExcelAwards: (filters) => axios.post('awards/excel', filters),
    getExcelAwardsExchanges: () => axios.get('award-exchanges/excel'),

    //tracking
    getTracking: (exchangeId) => axios.get(`award-exchanges/${exchangeId}/tracking`),
    storeTracking: (data) => axios.post('award-exchanges/tracking/store', data),
    deleteTracking: (id) => axios.post('award-exchanges/tracking/delete', id),
}